import { StyleSheet } from 'react-native';
import {
  CELEBRATION_COLORS,
  FORGE_BADGE_SIZE,
  FORGE_STAGE_SIZE,
} from '../../constants/celebrations.constants';

// Colors are design-system constants (celebration design file), not theme-derived
export const getRankUpCelebrationStyles = () =>
  StyleSheet.create({
    scrim: {
      flex: 1,
      backgroundColor: CELEBRATION_COLORS.SCRIM,
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: 24,
      paddingVertical: 32,
    },
    stage: {
      width: FORGE_STAGE_SIZE,
      height: FORGE_STAGE_SIZE,
      alignItems: 'center',
      justifyContent: 'center',
    },
    stageCenterAbs: {
      position: 'absolute',
      left: FORGE_STAGE_SIZE / 2 - FORGE_BADGE_SIZE / 2,
      top: FORGE_STAGE_SIZE / 2 - FORGE_BADGE_SIZE / 2,
      width: FORGE_BADGE_SIZE,
      height: FORGE_BADGE_SIZE,
    },
    badgeImg: {
      width: FORGE_BADGE_SIZE,
      height: FORGE_BADGE_SIZE,
    },
    fragmentClip: {
      position: 'absolute',
      width: FORGE_BADGE_SIZE / 2,
      height: FORGE_BADGE_SIZE / 2,
      overflow: 'hidden',
    },
    raysWrap: {
      position: 'absolute',
      left: FORGE_STAGE_SIZE / 2 - 160,
      top: FORGE_STAGE_SIZE / 2 - 160,
      width: 320,
      height: 320,
    },
    flashWrap: {
      position: 'absolute',
      left: FORGE_STAGE_SIZE / 2 - 100,
      top: FORGE_STAGE_SIZE / 2 - 100,
      width: 200,
      height: 200,
    },
    textBlock: {
      alignItems: 'center',
      marginTop: 20,
    },
    transitionText: {
      fontSize: 13,
      fontWeight: '700',
      letterSpacing: 2.8,
      color: CELEBRATION_COLORS.GOLD,
    },
    rankNameText: {
      fontSize: 38,
      fontWeight: '800',
      letterSpacing: -0.4,
      color: CELEBRATION_COLORS.TEXT,
      marginTop: 4,
    },
    levelChip: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 6,
      marginTop: 10,
      backgroundColor: CELEBRATION_COLORS.SURFACE,
      borderRadius: 999,
      paddingVertical: 6,
      paddingHorizontal: 14,
    },
    levelChipText: {
      fontSize: 13,
      fontWeight: '600',
      color: '#D1D5DB',
    },
    xpBlock: {
      width: '100%',
      maxWidth: 280,
      marginTop: 24,
    },
    barTrack: {
      height: 8,
      backgroundColor: CELEBRATION_COLORS.TRACK,
      borderRadius: 999,
      overflow: 'hidden',
    },
    barFill: {
      height: '100%',
      borderRadius: 999,
    },
    barLabels: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginTop: 7,
    },
    barLabelText: {
      fontSize: 12,
      color: CELEBRATION_COLORS.MUTED,
      fontVariant: ['tabular-nums'],
    },
    buttons: {
      width: '100%',
      maxWidth: 280,
      marginTop: 26,
      gap: 10,
    },
    continueBtn: {
      minHeight: 48,
      backgroundColor: CELEBRATION_COLORS.PURPLE,
      borderRadius: 10,
      alignItems: 'center',
      justifyContent: 'center',
      shadowColor: CELEBRATION_COLORS.PURPLE,
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.3,
      shadowRadius: 4,
      elevation: 4,
    },
    continueText: {
      fontSize: 16,
      fontWeight: '700',
      color: CELEBRATION_COLORS.INK,
    },
    shareBtn: {
      minHeight: 44,
      backgroundColor: 'transparent',
      borderWidth: 1,
      borderColor: CELEBRATION_COLORS.TRACK,
      borderRadius: 10,
      alignItems: 'center',
      justifyContent: 'center',
    },
    shareText: {
      fontSize: 15,
      fontWeight: '600',
      color: CELEBRATION_COLORS.TEXT,
    },
    btnPressed: {
      transform: [{ scale: 0.97 }],
    },
  });
